import EmptyState from "../components/EmptyState";

export default function DashboardAlerts({ alerts }) {
  if (!alerts.length) {
    return <EmptyState text="No active alerts." />;
  }

  return (
    <div className="flex flex-column gap-3">
      {alerts.map((alert, index) => (
        <div className={`alert alert-${alert.type}`} key={`${alert.message}-${index}`}>
          {alert.message}
        </div>
      ))}
    </div>
  );
}